<template>
  <div class="chart-container">
    <VChart :option="chartOptions" autoresize v-if="hasChartSeries" />
    <div class="font-italic text-muted w-100 h-100" v-if="!hasChartSeries" style="display: flex">
      <div class="m-auto">No data available</div>
    </div>
    <div class="chart-tools" v-if="hasChartSeries">
      <FormButton class="btn-default btn-sm" v-if="exportEnabled" @click="displayExport" title="Export"><i class="far fa-file-export"></i></FormButton>
      <FormButton class="btn-default btn-sm ml-2" v-if="popupEnabled" @click="displayPopup" title="Fullscreen"><i class="far fa-expand"></i></FormButton>
    </div>
  </div>
</template>

<style scoped>
.chart-container {
  position: relative;
  width: 100%;
  height: 100%;
}
.chart-tools {
  position: absolute;
  top: 10px;
  right: 10px;
  width: auto;
  height: auto;
  text-align: right;
}
</style>

<script>
import _ from 'lodash'

import { use } from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';
import { BarChart, LineChart } from 'echarts/charts';
import { TitleComponent, TooltipComponent, LegendComponent, GridComponent, GraphicComponent, MarkLineComponent, MarkPointComponent, MarkAreaComponent } from 'echarts/components';
import VChart from 'vue-echarts';

import ChartBarPopupDialog from '@/components/dialog/chartBarPopupDialog'
import ChartBarExportDialog from '@/components/dialog/chartBarExportDialog'

use([
  CanvasRenderer,
  BarChart,
  LineChart,
  GridComponent,
  GraphicComponent,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  MarkLineComponent,
  MarkPointComponent,
  MarkAreaComponent
]);

export default {
  name: 'ChartLine',
  components: {
    VChart
  },
  props: {
    title: String,
    series: Array,
    xAxis: [Array, Object],
    yAxis: [Array, Object],
    legend: [Array, Object],
    options: Object,

    // Options
    popupEnabled: Boolean,
    exportEnabled: Boolean
  },
  computed: {
    hasChartSeries() {
      if(this.series) {
        return this.series.some(series => {
          if(series.data && series.data.length > 0)
            return true
        })
      }
      return false
    },
    chartOptions() {
      var output = {}

      output.legend = this.legend
      output.xAxis = this.xAxis
      output.yAxis = this.yAxis
      output.series = this.series

      // Default options
      output.tooltip = {
        trigger: 'axis'
      },

      _.merge(output, this.options)

      return output
    }
  },
  methods: {
    displayPopup() {
      this.displayModal(ChartBarPopupDialog, {
        title: this.title
      }, {
        series: this.series,
        xAxis: this.xAxis,
        yAxis: this.yAxis,
        legend: this.legend,
        options: this.options
      })
      .then(() => {
      })
    },
    displayExport() {
      this.displayModal(ChartBarExportDialog, {
        title: this.title
      }, {
        series: this.series,
        xAxis: this.xAxis,
        yAxis: this.yAxis,
        legend: this.legend,
        options: this.options
      })
      .then(() => {
      })
    }
  }
}
</script>